import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

const KEY = "ajs_cookie_consent";
export const openCookieSettings = () => window.dispatchEvent(new Event("ajs-cookie-settings"));
export const cookieConsent = () => localStorage.getItem(KEY);

export const CookieBanner = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(() => !localStorage.getItem(KEY));
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener("ajs-cookie-settings", show);
    return () => window.removeEventListener("ajs-cookie-settings", show);
  }, []);
  const choose = (v) => { localStorage.setItem(KEY, v); setOpen(false); };
  return (
    <AnimatePresence>
      {open && (
        <motion.div data-testid="cookie-banner" initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 40, opacity: 0 }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:start-6 sm:max-w-md z-40 bg-[#0f0e0c]/95 backdrop-blur-xl border border-[#c9a55c]/30 p-5 shadow-2xl">
          <p className="font-display text-xl mb-2">{t("cookie_title")}</p>
          <p className="text-xs text-white/65 leading-relaxed mb-4">
            {t("cookie_text")} <Link data-testid="cookie-policy-link" to="/cookies" className="underline text-white/85">{t("cookie_more")}</Link>
          </p>
          <div className="flex gap-2">
            <button data-testid="cookie-accept-all" onClick={() => choose("all")} className="btn-gold flex-1 h-11 text-xs">{t("cookie_accept")}</button>
            <button data-testid="cookie-necessary-only" onClick={() => choose("necessary")} className="flex-1 h-11 text-xs uppercase tracking-[0.15em] border border-white/20 hover:border-white/50 transition-colors">{t("cookie_necessary")}</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
